import React, { useEffect } from "react";
import styled from "styled-components";

const MarkerContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
`;

const Marker = styled.div`
  position: absolute;
  width: 12px;
  height: 12px;
  background: ${(props) => props.color || "#005fcc"};
  border: 2px solid white;
  border-radius: ${(props) => (props.type === "lift" ? "2px" : "50%")};
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.3);
  transform: translate(-50%, -50%);
  cursor: pointer;
  pointer-events: auto;
  z-index: 1;
`;

const POIMarkers = ({ markerScreenPositions, setSelectedRegionId }) => {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        setSelectedRegionId(null);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [setSelectedRegionId]);

  return null;
  // <MarkerContainer>
  //   {Object.values(markerScreenPositions).map((marker) => (
  //     <Marker
  //       key={marker.id}
  //       className="poi-marker"
  //       type={marker.poi.type}
  //       style={{
  //         left: marker.x,
  //         top: marker.y,
  //         background:
  //           marker.poi.type === "lift"
  //             ? "#666666"
  //             : marker.poi.difficulty === "green"
  //               ? "#4CAF50"
  //               : marker.poi.difficulty === "blue"
  //                 ? "#2196F3"
  //                 : marker.poi.difficulty === "orange"
  //                   ? "#FF9800"
  //                   : marker.poi.difficulty === "black"
  //                     ? "#000000"
  //                     : "#FFFFFF",
  //       }}
  //       onClick={() => setSelectedRegionId(marker.id)}
  //     />
  //   ))}
  // </MarkerContainer>
};

export default POIMarkers;
